import ReactGA from "react-ga4";

// Initialize GA4 - Replace with your actual GA4 Measurement ID
const GA4_MEASUREMENT_ID =
  import.meta.env.VITE_GA4_MEASUREMENT_ID || "G-XXXXXXXXXX";

export const initAnalytics = () => {
  try {
    if (GA4_MEASUREMENT_ID && GA4_MEASUREMENT_ID !== "G-XXXXXXXXXX") {
      ReactGA.initialize(GA4_MEASUREMENT_ID);
      console.log("Analytics initialized");
    } else {
      console.log("Analytics not initialized - no GA4 Measurement ID provided");
    }
  } catch (error) {
    console.log("Analytics not initialized - error:", error);
  }
};

// Custom event tracking functions
export const trackEvent = (
  action: string,
  category: string,
  label?: string,
  value?: number,
  nonInteraction?: boolean
) => {
  try {
    console.log("📊 GA4 Event:", { category, action, label, value, nonInteraction });
    ReactGA.event({
      category,
      action,
      label,
      value,
      nonInteraction: nonInteraction || false,
    });
  } catch (error) {
    console.log("Analytics event failed:", error);
  }
};

// Page view tracking
export const trackPageView = (path: string) => {
  try {
    ReactGA.send({ hitType: "pageview", page: path });
  } catch (error) {
    console.log("Analytics pageview failed:", error);
  }
};

// Language change tracking
export const trackLanguageChange = (language: string) => {
  trackEvent("language_change", "User Preferences", language);
};

// Rating change tracking
export const trackRatingChange = (lifeArea: string, rating: number) => {
  trackEvent("rating_change", "Life Area Rating", lifeArea, rating);
};

// Color picker tracking
export const trackColorChange = (lifeArea: string, color: string) => {
  trackEvent("color_change", "Customization", lifeArea, 1);
};

// Form completion tracking
export const trackFormCompletion = () => {
  trackEvent("form_completion", "User Journey", "wheel_of_life_form");
};

// Wheel download tracking
export const trackWheelDownload = () => {
  trackEvent("wheel_download", "User Actions", "wheel_image_download");
};

// Donation click tracking
export const trackDonationClick = () => {
  trackEvent("donation_click", "Conversion", "donation_banner_click");
};

// Step progression tracking
export const trackStepProgression = (step: "rate" | "view") => {
  trackEvent("step_progression", "User Journey", step);
};

// Ad interaction tracking
export const trackAdInteraction = (position: string) => {
  trackEvent("ad_interaction", "Monetization", position);
};

// Error tracking
export const trackError = (error: string, context?: string) => {
  trackEvent("error", "Technical", context || "unknown", 1);
};

export const sendToAnalytics = (metric: any, ...args: any[]) => {
  // Handle both object and individual parameter formats
  let id, name, value;
  
  if (typeof metric === 'object' && metric !== null) {
    // Web Vitals passes an object with id, name, value properties
    id = metric.id;
    name = metric.name;
    value = metric.value;
  } else {
    // Fallback for individual parameters (id, name, value)
    id = metric;
    name = args[0];
    value = args[1];
  }
  
  trackEvent(
    name,
    "Web Vitals",
    id,
    Math.round(name === "CLS" ? value * 1000 : value)
  );
};

